<script>
import options from "./AmountSelector.options";
export default options;
</script>

<template>
  <article
    class="kb-selector kb-amount-selector"
    :class="{ 'kb-validation-error': displayError }"
  >
    <label class="kb-amount-selector__label" for="amountSelector">{{label}}</label>
    <div class="kb-selector__wrapper">
      <input
        :id="id"
        @input="preventWrongInput"
        type="number"
        :min="minAmount"
        :max="maxAmount"
        v-model="amount"
        required="required"
        :aria-describedby="ariaDescribedby"
      />
    </div>
  </article>
</template>
